import { Accordion, AccordionSummary, styled } from '@mui/material';
import { sectionExpandIconWrapperSx } from './section-expand-icon-sx';

export const FlatAccordion = styled(Accordion)(() => ({
  '&&': {
    backgroundColor: 'transparent',
    backgroundImage: 'none',
    boxShadow: 'none',
    margin: 0,
    transition: 'none',
    '&::before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      margin: 0,
    },
  },
}));

export const FlatAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  '&&': {
    minHeight: 0,
    padding: 0,
    transition: 'none',
    '&.Mui-expanded': {
      minHeight: 0,
    },
  },
  '&& .MuiAccordionSummary-content': {
    margin: 0,
    minHeight: '2rem',
    transition: 'none',
    '&.Mui-expanded': {
      margin: 0,
    },
  },
  '&& .MuiAccordionSummary-expandIconWrapper': sectionExpandIconWrapperSx(theme),
}));
